import {
  smallSmartphonePortrait,
  smartphonePortrait,
  smartphoneLandscape,
  tabletLandscape,
  desktop,
} from '@/utils/media-query-list';

export default {
  isSmallSmartphonePortrait: smallSmartphonePortrait.matches,
  isSmartphonePortrait: smartphonePortrait.matches,
  isSmartphoneLandscape: smartphoneLandscape.matches,
  isTabletLandscape: tabletLandscape.matches,
  isDesktop: desktop.matches,
  scrollbarWidth: null,
  offlineMode: false,
};
